// Tracks which changelog entry the user has last dismissed from the What's New toast

const STORAGE_KEY = "dismissedWhatsNew";

export const isWhatsNewDismissed = (version) => {
  return localStorage.getItem(STORAGE_KEY) === version;
};

export const dismissWhatsNew = (version) => {
  localStorage.setItem(STORAGE_KEY, version);
};

/**
 * Parses a changelog entry title into a Date. Supports the formats used in
 * src/constants/changelog.ts: "MM/YYYY", "MM/DD/YYYY", "MM/DD/YY".
 * Returns null if the title doesn't match a known date format.
 */
export const parseChangelogDate = (title) => {
  const parts = title.split("/").map(Number);
  if (parts.some(Number.isNaN)) return null;

  let month, day, year;
  if (parts.length === 2) {
    [month, year] = parts;
    day = 1;
  } else if (parts.length === 3) {
    [month, day, year] = parts;
    if (year < 100) year += 2000;
  } else {
    return null;
  }

  const date = new Date(year, month - 1, day);
  return Number.isNaN(date.getTime()) ? null : date;
};

/**
 * True if the changelog entry's date is more than `months` months before now.
 * Entries whose title can't be parsed as a date are treated as not stale
 * (fail open, so an unrecognized format doesn't silently hide the toast).
 */
export const isOlderThanMonths = (title, months, now = new Date()) => {
  const entryDate = parseChangelogDate(title);
  if (!entryDate) return false;

  const cutoff = new Date(now.getFullYear(), now.getMonth() - months, now.getDate());
  return entryDate < cutoff;
};
